<template>
	<section class="Progress">
		<div class="bar" :style="{ '--percent': currentStep / totalSteps }" :data-step="`${currentStep} / ${totalSteps}`"></div>
		<div class="buttons">
			<A @click="onClickPrev" :class="{ on: hasPrev }">&lt;</A>
			<A @click="onClickNext" :class="{ on: hasNext }">&gt;</A>
		</div>
	</section>
</template>

<script>
	import { mapState } from 'vuex';
	import store from '../../../store';
	import whevent from 'whevent';

	export default {
		data() {
			return {
				totalSteps: 10,
				currentStep: 1,
				stepStack: []
			};
		},
		computed: {
			...mapState(['currentAction', 'currentGroup', 'chats']),

			hasNext() {
				return this.stepStack.length > 0;
			},

			hasPrev() {
				return store.state.chats[0]?.aid !== this.currentAction?.aid;
			}
		},

		methods: {
			onActionChanged() {
				this.totalSteps = this.currentGroup.actions.length;
				this.currentStep = this.currentGroup.actions.findIndex(({ aid }) => aid == this.currentAction.aid) + 1;
				// console.log('watch', this.currentAction, this.currentGroup);
			},

			onClickPrev() {
				this.stepStack = [...this.stepStack, store.state.currentAction];
				store.state.chats = store.state.chats.filter(c => c.from !== 'user' && c.aid !== store.state.currentAction.aid);
				store.state.currentAction = store.state.chats[store.state.chats.length - 1];
			},

			onClickNext() {
				if (this.hasNext) {
					const action = this.stepStack[this.stepStack.length - 1];
					this.stepStack = this.stepStack.filter((e, i) => i !== this.stepStack.length - 1);
					if (action) {
						store.state.chats = [...store.state.chats, action];
						store.state.currentAction = action;
					}
				}
			},

			onSendChat() {
				this.stepStack = [];
			}
		},

		watch: {
			currentAction() {
				this.onActionChanged();
			}
		},

		mounted() {
			this.onActionChanged();
			whevent.on('SEND_CHAT', this.onSendChat, this);
		}
	};
</script>

<style lang="scss" scoped>
	.Progress {
		position: relative;
		height: 4.8rem;
		width: 100%;
		background-color: #222;

		.buttons {
			position: absolute;
			height: 100%;
			width: 100%;
			top: 0;
			left: 0;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0 2rem;

			.A {
				opacity: 0;
				pointer-events: none;
				font-size: 2rem;
				color: rgba(0, 0, 0, 0.75);
				display: flex;
				width: 3rem;
				height: 3rem;
				align-items: center;
				justify-content: center;
				font-weight: bold;
				border-radius: 2px;

				&:first-child {
					color: #222;

					&:hover {
						background-color: #222;
						color: var(--clrTheme);
					}
				}

				&:last-child {
					color: var(--clrTheme);

					&:hover {
						background-color: var(--clrTheme);
						color: #222;
					}
				}

				&.on {
					opacity: 1;
					pointer-events: all;
				}
			}
		}

		.bar {
			position: absolute;
			height: 100%;
			width: 100%;
			top: 0;
			left: 0;
			font-size: 2rem;

			&::before,
			&::after {
				content: attr(data-step);
				text-align: center;
				display: flex;
				align-items: center;
				justify-content: center;
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
			}

			&::before {
				color: var(--clrTheme);
			}

			&::after {
				clip-path: inset(0 calc(100% - var(--percent) * 100%) 0 0);
				background-color: var(--clrTheme);
				color: #222;
				transition: clip-path 0.3s;
			}
		}
	}
</style>
